// Sino: aparelhos do App Facial Coletivo aguardando autorização (matriz + filiais)
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Smartphone, ShieldCheck, ShieldOff } from "lucide-react";
import { api } from "@/lib/api";

const fmtDH = (s) => (s ? new Date(s).toLocaleString("pt-BR") : "");

export const AvisosAparelhos = ({ onChange }) => {
  const [itens, setItens] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/notificacoes-admin/aparelhos").then((r) => setItens(r.data || [])).catch(() => setItens([]));
  useEffect(() => { load(); }, []);
  const acao = async (d, a) => {
    if (a === "revogar" && !window.confirm(`Recusar o aparelho "${d.nome}"? Ele não poderá registrar ponto.`)) return;
    setBusy(d.id);
    try {
      await api.post(`/notificacoes-admin/aparelhos/${d.id}/${a}`);
      toast.success(a === "autorizar" ? "Aparelho autorizado" : "Aparelho recusado");
      load(); onChange?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha"); }
    finally { setBusy(""); }
  };
  if (itens === null) return <div className="text-center text-slate-400 py-8"><Loader2 size={18} className="animate-spin mx-auto" /></div>;
  if (!itens.length) return <div className="text-center text-slate-400 py-8 text-sm" data-testid="avisos-aparelhos-vazio">Nenhum aparelho aguardando autorização.</div>;
  return (
    <ul className="space-y-2" data-testid="avisos-aparelhos-lista">
      {itens.map((d) => (
        <li key={d.id} className="border border-amber-200 bg-amber-50 rounded-lg p-3 text-sm flex items-center gap-3 flex-wrap" data-testid={`aviso-aparelho-${d.id}`}>
          <Smartphone size={18} className="text-amber-600 shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="font-semibold">{d.nome || "Aparelho"} — aguardando autorização</div>
            <div className="text-[11px] text-slate-600 truncate">{d.empresa_nome} · cadastrado em {fmtDH(d.created_at)}</div>
            <div className="text-[10px] text-slate-400 truncate" title={d.plataforma}>{d.plataforma}</div>
          </div>
          <button onClick={() => acao(d, "autorizar")} disabled={busy === d.id} data-testid={`btn-aviso-autorizar-${d.id}`}
            className="h-8 px-3 rounded-lg bg-emerald-600 text-white text-xs font-semibold inline-flex items-center gap-1 disabled:opacity-50"><ShieldCheck size={12} /> Autorizar</button>
          <button onClick={() => acao(d, "revogar")} disabled={busy === d.id} data-testid={`btn-aviso-recusar-${d.id}`}
            className="h-8 px-3 rounded-lg border border-rose-300 text-rose-700 text-xs font-semibold inline-flex items-center gap-1 disabled:opacity-50"><ShieldOff size={12} /> Recusar</button>
        </li>
      ))}
    </ul>
  );
};
